import DashboardLayout from "custom/LayoutContainers/DashboardLayout";
import DashboardNavbar from "custom/Navbars/DashboardNavbar";
import Alert from "custom/Alert";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import { Form, Formik } from "formik";
import { Card, Grid, Icon, Switch } from "@mui/material";
import SuiTypography from "components/SuiTypography";
import validations from "layouts/pages/users/new-user/schemas/validations";
import { connect } from "react-redux";
import CustomFormField from "components/CustomFormField";
import { useEffect, useRef, useState } from "react";
import MaterialUpload from "layouts/material/components/MaterialUpload";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import axios from "axios";
import initialValues from "layouts/pages/users/new-user/schemas/initialValues";
import Swal from "sweetalert2";
import { useLocation, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import PropTypes from "prop-types";
import { saveSoundMaterialItems, getSoundMaterialTypeLookups } from "redux/actions/pages";
import { SOUND_MATERIAL_TYPE, BASE_URL } from "redux/actions/constants";

function NewSoundItem({ saveItems, getLookups, lookups, localizations }) {
  const [soundItems, setSoundItems] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [currentFile, setCurrentFile] = useState(null);
  const formikRef = useRef();
  const [materialUrl, setMaterialUrl] = useState("");
  const location = useLocation();
  const history = useHistory();
  const selectedLetter = location.state?.selectedLetter;

  useEffect(() => {
    if (selectedLetter && formikRef.current) {
      formikRef.current.setFieldValue("letter", selectedLetter);
    }
  }, [selectedLetter]);

  useEffect(() => {
    // Ses materyal tiplerini çek
    getLookups();
  }, [getLookups]);

  const uploadFile = async (file) => {
    try {
      const fileSizeMB = file.size / 1024 / 1024;
      if (fileSizeMB > 20) {
        Swal.fire({
          icon: "error",
          title: "HATA!",
          text: "Yüklediğiniz materyal 20 MB boyutunu geçmektedir.",
          confirmButtonText: "Tamam",
        });
        return;
      }
      setIsUploading(true);
      const extension = file.name.split(".").pop();
      const fileName = `${Date.now()}.${extension}`;
      const { data } = await axios.get(
        `${BASE_URL}/api/upload/get-do-presigned-url?type=${file.type}&folder=${fileName}&extention=${extension}`
      );

      const { key, url } = data;
      const xhr = new XMLHttpRequest();
      xhr.open("PUT", url);
      xhr.setRequestHeader("Content-Type", file.type);
      xhr.setRequestHeader("x-amz-acl", "public-read");
      xhr.send(file);

      xhr.onload = () => {
        if (xhr.status === 200) {
          const fileUrl = `https://edictdigitalspaces.fra1.digitaloceanspaces.com/${key}`;
          setMaterialUrl(fileUrl);
          formikRef.current?.setFieldValue("fileUrl", fileUrl);
        } else {
          // eslint-disable-next-line no-console
          console.error(xhr.statusText);
        }
        setIsUploading(false);
      };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Dosya yükleme hatası:", error);
      setIsUploading(false);
    }
  };

  const onMaterialChange = (e) => {
    const file = e?.target?.files?.[0];
    if (!file) return;
    setCurrentFile(file);
    formikRef.current?.setFieldValue("file", file);
    uploadFile(file);
  };

  const handleSubmit = () => {
    const { values, resetForm } = formikRef.current;
    const { letter, name, type } = values;

    if (currentFile && letter && name && type) {
      const newItem = {
        id: Date.now().toString(),
        letter: letter.value,
        file: materialUrl,
        name,
        type: type.value,
        isActive: true,
        order: soundItems.length + 1,
      };
      setSoundItems((prev) => [...prev, newItem]);
      setCurrentFile(null);
      setMaterialUrl("");
      resetForm();

      if (selectedLetter) {
        setTimeout(() => {
          formikRef.current?.setFieldValue("letter", selectedLetter);
        }, 0);
      }
    }
  };

  const handleDeleteItem = (id) => {
    Swal.fire({
      icon: "question",
      title: "Silmek istediğinize emin misiniz?",
      showDenyButton: true,
      confirmButtonText: "Evet",
      denyButtonText: "Hayır",
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedItems = soundItems.filter((i) => i.id !== id);
        const reorderedItems = updatedItems.map((item, index) => ({
          ...item,
          order: index + 1,
        }));
        setSoundItems(reorderedItems);
      }
    });
  };

  const handleToggleActive = (id) => {
    setSoundItems((prev) =>
      prev.map((item) => (item.id === id ? { ...item, isActive: !item.isActive } : item))
    );
  };

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const items = [...soundItems];
    const [movedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, movedItem);
    const reorderedItems = items.map((item, index) => ({
      ...item,
      order: index + 1,
    }));
    setSoundItems(reorderedItems);
  };

  const onMaterialRemove = () => {
    setMaterialUrl("");
    setCurrentFile(null);
    formikRef.current?.setFieldValue("file", null);
    formikRef.current?.setFieldValue("fileUrl", "");
  };

  const onSaveClicked = () => {
    // Boş öğeleri filtrele
    const validSoundItems = soundItems.filter(
      (item) => item && item.letter && item.name && item.file && item.type
    );

    const soundItemsWithoutId = validSoundItems.map((item) => {
      const { id, ...itemWithoutId } = item;
      return itemWithoutId;
    });
    saveItems({ items: soundItemsWithoutId });
    Swal.fire({
      icon: "success",
      title: "Başarılı!",
      text: "Ses materyalleri başarıyla kaydedildi.",
      confirmButtonText: "Tamam",
    }).then(() => {
      history.push("/sound-item");
    });
  };

  const typeOptions =
    lookups && lookups[SOUND_MATERIAL_TYPE]
      ? lookups[SOUND_MATERIAL_TYPE].lookupValues.map((lv) => ({
          value: lv.lookupValueKey,
          label:
            localizations && localizations[lv.lookupValueKey]
              ? localizations[lv.lookupValueKey]
              : lv.lookupValueKey,
        }))
      : [
          { value: "CLASSROOM", label: "Sınıf İçi Çalışmalar" },
          { value: "ASSESSMENT_TOOLS", label: "Ölçme ve Değerlendirme Araçları" },
          { value: "BOARDS_AND_CARDS", label: "Pano ve Kartlar" },
        ];

  return (
    <>
      <Alert />
      <DashboardLayout>
        <DashboardNavbar />
        <SuiBox mt={3} mb={8}>
          <Formik
            innerRef={formikRef}
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validations.validation}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              setFieldValue,
              setFieldTouched,
            }) => (
              <Form autoComplete="off">
                <Card>
                  <SuiBox p={3}>
                    <SuiTypography variant="h5" fontWeight="bold">
                      Yeni Ses Materyali
                    </SuiTypography>
                    {/* Materyal yükleme ve form alanları */}
                    <SuiBox mt={3}>
                      <Grid container spacing={3}>
                        {/* Materyal yükleme alanı */}
                        <Grid item xs={12} md={4} minWidth="24vw">
                          <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                            <SuiTypography component="label" variant="caption" fontWeight="bold">
                              Materyal Yükle
                            </SuiTypography>
                          </SuiBox>
                          <MaterialUpload
                            height={250}
                            minWidth={500}
                            url={materialUrl}
                            removeBtnRight="0"
                            onMaterialRemove={onMaterialRemove}
                            onMaterialChange={onMaterialChange}
                            acceptedFiles=".pdf"
                          />
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <Grid container spacing={2} direction="column">
                            <Grid item xs={12}>
                              <CustomFormField
                                type="text"
                                name="letter"
                                label="Ses"
                                value={selectedLetter.label}
                                disabled
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <CustomFormField
                                type="text"
                                name="name"
                                label="İsim"
                                value={values.name || ""}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.name && touched.name}
                                success={Boolean(values.name && !errors.name)}
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <CustomFormField
                                type="select"
                                name="type"
                                label="Tip"
                                placeholder="Tip Seçiniz"
                                options={typeOptions}
                                value={
                                  values.type
                                    ? typeOptions.find((opt) => opt.KEY === values.type)
                                    : null
                                }
                                onChange={(selectedOption) =>
                                  setFieldValue("type", selectedOption ? selectedOption.KEY : "")
                                }
                                onBlur={() => setFieldTouched("type", true)}
                                error={errors.type && touched.type}
                                success={Boolean(values.type && !errors.type)}
                                setFieldValue={setFieldValue}
                                setFieldTouched={setFieldTouched}
                                optionLabel="VALUE"
                                optionValue="KEY"
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12}>
                          <SuiButton
                            variant="gradient"
                            color="dark"
                            onClick={() => {
                              handleSubmit();
                            }}
                            disabled={isUploading || !values.name || !values.type || !materialUrl}
                          >
                            {isUploading || !values.name || !values.type || !materialUrl
                              ? "Formu Tamamlayın..."
                              : "Listeye Ekle"}
                          </SuiButton>
                        </Grid>
                      </Grid>
                    </SuiBox>
                    <SuiBox mt={4}>
                      <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId="soundItems">
                          {(provided) => (
                            <SuiBox
                              ref={provided.innerRef}
                              {...provided.droppableProps}
                              sx={{ minHeight: "100px" }}
                            >
                              {soundItems.length === 0 ? (
                                <SuiBox p={2}>
                                  <SuiTypography
                                    variant="button"
                                    color="text"
                                    fontWeight="regular"
                                    textAlign="center"
                                    sx={{ width: "100%", display: "inline-block" }}
                                  >
                                    Henüz eklenmiş ses materyali bulunmamaktadır.
                                  </SuiTypography>
                                </SuiBox>
                              ) : (
                                soundItems.map((item, index) => (
                                  <Draggable key={item.id} draggableId={item.id} index={index}>
                                    {(dragProvided) => (
                                      <SuiBox
                                        ref={dragProvided.innerRef}
                                        {...dragProvided.draggableProps}
                                        {...dragProvided.dragHandleProps}
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        p={2}
                                        mb={1}
                                        sx={{
                                          border: "1px solid #eee",
                                          borderRadius: "8px",
                                          background: "#fff",
                                        }}
                                      >
                                        <SuiBox display="flex" alignItems="center">
                                          <Icon sx={{ cursor: "move" }}>drag_indicator</Icon>
                                          <SuiBox ml={2}>
                                            <SuiTypography
                                              variant="button"
                                              fontWeight="medium"
                                              textTransform="capitalize"
                                            >
                                              {item.name}
                                            </SuiTypography>
                                          </SuiBox>
                                        </SuiBox>
                                        <SuiBox display="flex" alignItems="center">
                                          <Switch
                                            checked={item.isActive}
                                            onChange={() => handleToggleActive(item.id)}
                                          />
                                          <SuiBox ml={2}>
                                            <SuiButton
                                              variant="text"
                                              color="error"
                                              onClick={() => handleDeleteItem(item.id)}
                                            >
                                              <Icon>delete</Icon>
                                            </SuiButton>
                                          </SuiBox>
                                        </SuiBox>
                                      </SuiBox>
                                    )}
                                  </Draggable>
                                ))
                              )}
                              {provided.placeholder}
                            </SuiBox>
                          )}
                        </Droppable>
                      </DragDropContext>
                    </SuiBox>
                    <SuiBox mt={4} display="flex" justifyContent="flex-end">
                      <SuiButton
                        variant="gradient"
                        color="dark"
                        onClick={onSaveClicked}
                        disabled={soundItems.length === 0}
                      >
                        Kaydet
                      </SuiButton>
                    </SuiBox>
                  </SuiBox>
                </Card>
              </Form>
            )}
          </Formik>
        </SuiBox>
      </DashboardLayout>
    </>
  );
}

NewSoundItem.propTypes = {
  saveItems: PropTypes.func.isRequired,
  getLookups: PropTypes.func.isRequired,
  lookups: PropTypes.objectOf(PropTypes.any),
  localizations: PropTypes.objectOf(PropTypes.any),
};

NewSoundItem.defaultProps = {
  lookups: null,
  localizations: null,
};

const mapStateToProps = (state) => ({
  lookups: state.data.lookups,
  localizations: state.localization?.pairs,
});

const mapDispatchToProps = {
  saveItems: saveSoundMaterialItems,
  getLookups: getSoundMaterialTypeLookups,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewSoundItem);
